import { FormDialog } from "@dzambalaorg/mui-dialog-form";
import { SelectInput, TextInput } from "@dzambalaorg/mui-inputs-core";
import { RichTextEditor } from "@dzambalaorg/mui-inputs-draft";
import { AvatarInput } from "@dzambalaorg/mui-inputs-image-firebase";
import { ContractFeatures, ContractStatus, IContract } from "@framework/types";
import { IMutationProps, useDialogForm } from "@dzambalaorg/react-hooks";
import { BlockchainInfoPopover } from "@framework/shared";

import { validationSchema } from "./validation";

export interface ILootContractDialogFormProps extends IMutationProps, Pick<ReturnType<typeof useDialogForm>, "mode"> {
  open: boolean;
  selectedItem: IContract | null;
}

export const LootContractDialogForm = (props: ILootContractDialogFormProps) => {
  const { selectedItem, open, mode, ...rest } = props;

  if (!open || !selectedItem) {
    return null;
  }

  const {
    id,
    title,
    description,
    baseTokenURI,
    imageUrl,
    contractStatus,
    address,
    symbol,
    name,
    royalty,
    contractFeatures,
  } = selectedItem;

  const fixedValues = {
    id,
    title,
    address,
    description,
    contractStatus,
    imageUrl,
  };

  return (
    <FormDialog
      open={open}
      initialValues={fixedValues}
      validationSchema={validationSchema}
      message={`dialogs.${mode}`}
      testId="LootContractEditForm"
      action={
        mode === "edit" ? (
          <BlockchainInfoPopover
            name={name}
            symbol={symbol}
            address={address}
            baseTokenURI={baseTokenURI}
            contractFeatures={contractFeatures}
            {...(!contractFeatures.includes(ContractFeatures.SOULBOUND) && { royalty: `${royalty / 100}%` })}
          />
        ) : null
      }
      filter={({ title, description, imageUrl, contractStatus }) => ({
        title,
        description,
        imageUrl,
        contractStatus,
      })}
      {...rest}
    >
      <TextInput name="title" />
      <RichTextEditor name="description" />
      <SelectInput name="contractStatus" options={ContractStatus} disabledOptions={[ContractStatus.NEW]} />
      <AvatarInput name="imageUrl" />
    </FormDialog>
  );
};
